import{jsx as a}from"react/jsx-runtime";import t from"./atlassian/AtlassianFromPage.js";const s={atlassian:t},r=({provider:t="atlassian"})=>a(s[t],{showCurrentPageInAttachments:!0});export{r as default};
